/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../label/defs.defs.js'

const $nsid = 'com.atproto.temp.fetchLabels'

export { $nsid }

/**
 * Fetch all labels from a labeler created after a certain date.
 * @deprecated use queryLabels or subscribeLabels instead
 */
const main = l.query(
  $nsid,
  l.params({
    since: l.optional(l.integer()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 250 }), 50),
    ),
  }),
  l.jsonPayload({
    labels: l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
